import { Component } from '@angular/core';

@Component({
    selector: 'app-custom-header-ccfo',
    templateUrl: './custom-header-ccfo.component.html',
    styleUrls: ['./custom-header-ccfo.component.scss'],
})
export class CustomHeaderCcfoComponent {
}
